import {ReactionWidgetData} from '@dv5/domain'
import React, {CSSProperties, FC} from 'react'
import {ReactionPicker} from '../common/ReactionPicker'
import {useReactionWidgetUpdate} from "./useReactionWidgetUpdate"
import {canvasMoveService, WidgetResize} from '../../services/canvasMoveService'
import './ReactionWidgetToolbar.less'

interface Props {
    canvasId: string
    widgetId: string
    data: ReactionWidgetData
    toolbarStyles: CSSProperties
    left: number
    top: number
    width: number
    height: number
}

const SizeIcon: FC<{ size: number; active: boolean }> = ({ size, active }) => {
    const viewBox = 16
    const padding = size === 32 ? 4 : size === 48 ? 2.5 : 1
    const rx = size === 32 ? 1 : size === 48 ? 1.5 : 2
    const fillColor = active ? 'currentColor' : 'none'

    return (
        <svg width='14' height='14' viewBox={`0 0 ${viewBox} ${viewBox}`} fill='none' xmlns='http://www.w3.org/2000/svg'>
            <rect
                x={padding}
                y={padding}
                width={viewBox - padding * 2}
                height={viewBox - padding * 2}
                rx={rx}
                stroke='currentColor'
                strokeWidth='1.5'
                fill={fillColor}
            />
        </svg>
    )
}

const SIZE_PRESETS: Array<{ size: number; label: string }> = [
    { size: 32, label: '32 × 32' },
    { size: 48, label: '48 × 48' },
    { size: 64, label: '64 × 64' },
]

export const ReactionWidgetToolbar: FC<Props> = ({
    canvasId,
    widgetId,
    data,
    toolbarStyles,
    left,
    top,
    width,
    height,
}) => {
    const { updateData } = useReactionWidgetUpdate(canvasId, widgetId, data)

    const handleReactionChange = (reactionType: string) => {
        if (!reactionType) {
            return
        }
        updateData(['reactionType'], {reactionType})
    }

    const handleSizeChange = (event: React.MouseEvent<HTMLButtonElement>, newSize: number) => {
        event.preventDefault()
        event.stopPropagation()
        canvasMoveService.resizeWidgets(canvasId, [
            { id: widgetId, left, top, width: newSize, height: newSize } as WidgetResize,
        ])
    }

    return (
        <div className='reaction-widget-toolbar' style={toolbarStyles}>
            <ReactionPicker
                value={data.reactionType}
                allowEmpty={false}
                onChange={handleReactionChange}
            />
            <div className='reaction-widget-toolbar__divider' />
            <div className='reaction-widget-toolbar__size-presets'>
                {SIZE_PRESETS.map(({ size, label }) => (
                    <button
                        key={size}
                        className={`reaction-widget-toolbar__size-btn${width === size ? ' reaction-widget-toolbar__size-btn--active' : ''}`}
                        onMouseDown={event => handleSizeChange(event, size)}
                        title={label}
                    >
                        <SizeIcon size={size} active={width === size} />
                    </button>
                ))}
            </div>
        </div>
    )
}
